import { ReactNode } from 'react';

interface SectionProps {
  id?: string;
  children: ReactNode;
  className?: string;
  containerClassName?: string;
}

/** Consistent section shell: scroll offset, vertical rhythm, and centered container. */
const Section = ({
  id,
  children,
  className = '',
  containerClassName = '',
}: SectionProps) => {
  return (
    <section id={id} className={`scroll-mt-20 py-20 md:py-28 ${className}`}>
      <div className={`container-tight ${containerClassName}`}>{children}</div>
    </section>
  );
};

export default Section;
